var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.Input,{ref:"inputRef",attrs:{"state-key":_setup.usingStateKey,"custom-validator":_vm.customValidator},on:{"blur":_setup.handleBlur,"focus":_setup.handleFocus,"enter":_setup.handleEnter}},[_vm._t("suffix",null,{"slot":"suffix"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }